<template>
  <fragment>
    <v-toolbar elevation="1" height="50" color="#0F1547">
      <v-btn icon v-if="!cantGoBack" @click="closeModal">
        <v-icon style="color: white">mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title style="color: white">
        Exercices ENE
        <span v-if="this.onlyRefs">de référence</span></v-toolbar-title
      >

      <v-spacer></v-spacer>

      <v-btn color="success" small @click="validExercise" v-if="canValidateExercise()">
        <v-icon small>mdi-check-bold</v-icon>
        &nbsp; Valider
      </v-btn>
    </v-toolbar>

    <v-container fluid style="height: 778px; padding-top: 16px">
      <!-- Content -->
      <v-row class="overflow-hidden" style="max-height: 100%">
        <!-- List Exercises -->
        <v-col cols="8" class="d-flex flex-column" style="max-height: 100%">
          <v-data-table
            class="elevation-2"
            v-model="selectedExercise"
            :headers="headers"
            :items="exercices"
            item-key="id"
            :single-select="true"
            show-select
            :options.sync="options"
            :server-items-length="totalExercices"
            :footer-props="{
              'items-per-page-options': pageSizes,
            }"
            :items-per-page="pageSize"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <!-- Filters params -->
            <template v-slot:[`body.prepend`]>
              <tr>
                <td></td>
                <td>
                  <v-text-field
                    v-model="searchParams.title"
                    type="text"
                    label="Titre"
                    @input="isTyping = true"
                    clearable
                    @click:clear="onClearTitleClicked()"
                  ></v-text-field>
                </td>
                <td>
                  <v-select
                    v-model="searchParams.destinationType"
                    :items="filteredDestinationTypeItems"
                    attach
                    Destination
                    label="Destination"
                    @input="isTyping = true"
                    clearable
                    @click:clear="onClearDestinationClicked()"
                  ></v-select>
                </td>
                <td v-if="shouldDisplayDisciplineInTable()">
                  <v-text-field
                    v-model="searchParams.discipline"                    
                    type="text"
                    label="Discipline"
                    @input="isTyping = true"
                    clearable
                    @click:clear="onClearDisciplineClicked()"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    v-model="searchParams.user"
                    type="text"
                    label="Créateur"
                    @input="isTyping = true"
                    clearable
                    @click:clear="onClearUserClicked()"
                  ></v-text-field>
                </td>
                <td v-if="!onlyRefs">
                  <v-select
                    v-model="searchParams.exerciseType"
                    :items="exerciseTypeItems"
                    Type
                    attach
                    label="Type"
                    @input="isTyping = true"
                    clearable
                    @click:clear="onClearTypeClicked()"
                  ></v-select>
                </td>
              </tr>
            </template>
            <!-- DDL Destination Type -->
            <template v-slot:[`item.destinationType`]="{ item }">
              {{ destinationTypeItems.find((e) => e.value === item.destinationType).text }}
            </template>
            <!-- DDL Exercise Type -->
            <template v-slot:[`item.exerciseType`]="{ item }">
              {{ exerciseTypeItems.find((e) => e.value === item.exerciseType).text }}
            </template>
          </v-data-table>
        </v-col>
        <!-- Details Exercise -->
        <v-col cols="4" class="pr-5" style="max-height: 100%">
          <v-row v-if="selectedExercise[0]">
            <v-col cols="12">
              <v-card style="width: 100%; max-height: 100%">
                <div style="width: 100%; height: 100%" class="d-flex justify-content-center">
                  <!-- Preview -->
                  <img class="img-fluid" style="max-height: 480px" v-if="selectedExercise[0].preview" :src="selectedExercise[0].preview" />

                  <!-- Image -->
                  <img
                    v-else-if="
                      selectedExercise[0].firstMedia &&
                      (selectedExercise[0].firstMedia.image || selectedExercise[0].firstMedia.isImage) &&
                      !selectedExercise[0].firstMedia.src &&
                      !selectedExercise[0].firstMedia.videoOptions
                    "
                    class="img-fluid"
                    style="max-height: 480px"
                    :src="selectedExercise[0].firstMedia.image"
                  />
                  <!-- Video -->
                  <video-player
                    :key="componentKey"
                    v-else-if="selectedExercise[0].firstMedia && (selectedExercise[0].firstMedia.videoOptions || selectedExercise[0].firstMedia.youtube)"
                    style="width: 100%; height: auto; margin: 0"
                    :options="selectedExercise[0].firstMedia.videoOptions"
                  ></video-player>
                  <!-- IFrame -->
                  <iframe
                    v-else-if="selectedExercise[0].firstMedia && selectedExercise[0].firstMedia.canal"
                    style="width: 100%; height: auto; margin: 0"
                    :src="selectedExercise[0].firstMedia.src"
                  ></iframe>
                  <!-- Link -->
                  <a v-else-if="selectedExercise[0].firstMedia && selectedExercise[0].firstMedia.src" :href="selectedExercise[0].firstMedia.src" target="_blank">{{
                    selectedExercise[0].firstMedia.src
                  }}</a>
                </div>

                <!-- title -->
                <v-card-title style="color: #0f1547">{{ selectedExercise[0].title }}</v-card-title>
                <v-card-text>
                  <v-row align="center" class="mx-0">
                    <v-col cols="12" class="no-padding-sides">
                      <!-- Destination -->
                      <div class="mt-3" v-if="selectedExercise[0].destinationType">
                        <label class="font-weight-bold t-blue">Destination</label>
                        {{ destinationTypeItems.find((e) => e.value === selectedExercise[0].destinationType).text }}
                      </div>

                      <!-- Discipline -->
                      <div class="mt-3" v-if="selectedExercise[0].disciplineName">
                        <label class="font-weight-bold t-blue">Discipline</label>
                        {{ selectedExercise[0].disciplineName }}
                      </div>

                      <!-- Creator -->
                      <div class="mt-3" v-if="selectedExercise[0].email">
                        <label class="font-weight-bold t-blue">Créateur</label>
                        {{ selectedExercise[0].email }}
                      </div>

                      <!-- Type -->
                      <div class="mt-3" v-if="selectedExercise[0].exerciseType">
                        <label class="font-weight-bold t-blue">Type</label>
                        {{ exerciseTypeItems.find((e) => e.value === selectedExercise[0].exerciseType).text }}
                      </div>

                      <!-- Prerequis -->
                      <div class="mt-3" v-if="selectedExercise[0].prerequis">
                        <label class="font-weight-bold t-blue">Prérequis</label>
                        {{ selectedExercise[0].prerequis }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </fragment>
</template>

<script>
import { GetExercisesForCurrentUserLightAsync } from "@/api/exerciseApi";
import { bus } from "@/main";
import { ExerciceSortType } from "@/models/enums";
import { ExerciseType } from "@/models/enums";
import { DestinationType } from "@/models/enums";
import store from "@/store";
import AuthService from "@/services/AuthService";
import { Fragment } from "vue-fragment";

import VideoPlayer from "../../components/VideoPlayer.vue";
import { getDownloadMediaByPathAsync } from "../../api/mediaApi";

import _ from "lodash";

export default {
  name: "exercises-list-v2",

  components: {
    Fragment,
    VideoPlayer,
  },

  props: ["close", "canGoBack", "onlyRefs", "authorizedDestinationTypes", "isShowed", "gce"],

  data() {
    return {
      // Search part ===
      searchParams: {
        id: null,
        title: "",
        destinationType: null,
        user: "",
        exerciseType: "",
        discipline: "",
      },
      destinationTypeItems: [
        { text: "Transversal", value: DestinationType.PUBLIC },
        { text: "Fédéral", value: DestinationType.FEDERAL },
        { text: "Spécifique", value: DestinationType.DISCIPLINE },        
        { text: "Entraîneur", value: DestinationType.COACH },
      ],
      filteredDestinationTypeItems: [],
      DestinationTypes: DestinationType,
      exerciseTypeItems: [
        { text: "Exercice", value: ExerciseType.EXERCISE },
        { text: "Test (évaluation)", value: ExerciseType.EVALUATION },
        { text: "Situation de référence", value: ExerciseType.REFERENCE },
      ],
      isTyping: false,
      // Pagination part =======
      totalExercices: 0,
      options: {},
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10],
      userId: null,
      exercices: [],
      // Sort part ======
      sortBy: "id",
      sortDesc: true,
      // Others part ==
      exercises: [],
      id: null,
      title: null,
      destination: null,
      user: null,
      type: null,
      discipline: null,
      cantGoBack: !!this.canGoBack,
      selectedExercise: [],
      componentKey: 0,
    };
  },

  watch: {
    options: {
      handler() {
        // Refresh the exercice page with the provided parameters
        this.getExercicePage();
      },
      deep: true,
    },
    "searchParams.title": _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    "searchParams.destinationType": _.debounce(function () {
      this.isTyping = false;
    }, 100),
    "searchParams.user": _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    "searchParams.exerciseType": _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    "searchParams.discipline": _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    isTyping: function (value) {
      if (!value) {
        this.onFiltersChanged();
        // Refresh the exercice page with the provided parameters
        this.getExercicePage();
      }
    },
    selectedExercise: {
      handler() {
        this.componentKey += 1;
      },
      deep: true,
    },
    authorizedDestinationTypes: function (value) {
      this.getExercisesBasedOnAvailableDestinationTypes();
    },
  },

  computed: {
    headers() {
      var headers = [
        {
          text: "Titre",
          value: "title",
          width: "30%",
        },
        {
          text: "Destination",
          value: "destinationType",
          width: "15%",
        },
        {
          text: "Discipline",
          value: "disciplineName",
          width: "20%",
        },
        {
          text: "Créateur",
          value: "email",
          width: "15%",
        },
      ];

      // Display exercise type column only if several types
      if (!this.onlyRefs) {
        headers.push({
          text: "Type",
          value: "exerciseType",
          width: "20%",
        });
      }

      // if not discipline or coach, remove discipline column
      if(!this.shouldDisplayDisciplineInTable()) {
        _.remove(headers, (header) => header.value === "disciplineName");      
        headers[0].width = "35%"; 
        headers[2].width = "30%";  
      }

      return headers;
    },    
  },

  async mounted() {
    // first init the filtered list zith all the possible values
    this.filteredDestinationTypeItems = _.clone(this.destinationTypeItems);

    // then we wanna filter available destination types based on cycle destination type
    this.getExercisesBasedOnAvailableDestinationTypes();
  },

  methods: {
    // get Exercises Based On Available DestinationTypes
    getExercisesBasedOnAvailableDestinationTypes() {
      this.filterAvailableDestinationTypes();

      if (this.isShowed) {
        this.retrieveExercices();
      }
    },

    // Filter available destination types based on cycle destination type
    filterAvailableDestinationTypes() {
      // if the parameter is provided
      if (this.authorizedDestinationTypes) {
        // reset the filtered list
        this.filteredDestinationTypeItems = [];

        // for each possible destination type
        this.destinationTypeItems.forEach((destinationTypeItem) => {
          // if current possible destination type is part of the provided parameters
          let exists = _.find(this.authorizedDestinationTypes, (authorizedDestinationType) => authorizedDestinationType == destinationTypeItem.value);

          if (exists) {
            // add it to the filtered item list
            this.filteredDestinationTypeItems.push(destinationTypeItem);
          }
        });
      }
    },

    // Build the request params based on page parameters
    getRequestParams(userId, searchParams, page, pageSize, sortBy, sortDesc) {
      let params = {};
      if (userId) {
        params["userId"] = userId;
      }
      if (searchParams) {
        params["searchParams"] = searchParams;
      }
      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (sortBy) {
        params["sortBy"] = sortBy;
      }
      if (sortDesc) {
        params["sortDesc"] = sortDesc;
      }
      return params;
    },

    // Use request params to call REST API and get the paginated list of exercices
    async retrieveExercices() {
      const userId = AuthService.userId;
      this.userId = userId;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.page = page;
      this.pageSize = itemsPerPage;
      this.sortBy = sortBy;
      this.sortDesc = sortDesc;

      // Get the enum value of textual sort Exercice property in order to request the REST API
      var sortByEnum = this.convertExerciceTextPropertiesIntoEnum(sortBy[0]);

      // Get the search params if exists
      let searchParams = {};
      if (this.searchParams) {
        searchParams = {
          id: this.searchParams.id,
          title: this.searchParams.title ? this.searchParams.title.trim().toLowerCase() : "",
          destinationType: this.searchParams.destinationType ? this.searchParams.destinationType : DestinationType.UNDEFINED,
          user: this.searchParams.user ? this.searchParams.user.trim().toLowerCase() : "",
          discipline: this.searchParams.discipline ? this.searchParams.discipline.trim().toLowerCase() : "",
          exerciseType: this.searchParams.exerciseType ? this.searchParams.exerciseType : ExerciseType.UNDEFINED,
          selectedFederationId: this.gce.federationId ? this.gce.federationId : null,
          selectedDisciplineId: this.gce.disciplineId ? this.gce.disciplineId : null,
          selectedCoachId: this.gce.coach ? this.gce.coach.id : null,
          filteredAvailableDestinationTypes: this.filteredDestinationTypeItems ? this.filteredDestinationTypeItems.map((filteredDestinationTypeItem) => filteredDestinationTypeItem.value) : null,
        };
      }

      // Build the parameters
      const params = this.getRequestParams(this.userId, searchParams, this.page, this.pageSize, sortByEnum, this.sortDesc);

      // Call the REST API service
      await GetExercisesForCurrentUserLightAsync(params, this.onlyRefs)
        .then(async (response) => {
          const { exerciceDatatableItems, totalExercices } = response;
          this.exercices = exerciceDatatableItems;
          this.totalExercices = totalExercices;

          // wait for media load
          await this.loadSelectedExerciseFirstMedia();
        })
        .catch((e) => {
          // store.dispatch("setSnackbar", {
          //   title: "Erreur",
          //   text: "La récupération des exercices n'a pas fonctionnée.",
          //   color: "error",
          // });
        });
    },

    // Refresh the exercice page with the provided parameters
    getExercicePage() {
      this.retrieveExercices();
    },

    // Convert textual value of Exercice property into ExerciceSortType enum
    convertExerciceTextPropertiesIntoEnum(textProp) {
      var result = ExerciceSortType.UNDEFINED;

      switch (textProp) {
        case "id":
          result = ExerciceSortType.ID;
          break;
        case "title":
          result = ExerciceSortType.TITLE;
          break;
        case "destinationType":
          result = ExerciceSortType.DESTINATION;
          break;
        case "email":
          result = ExerciceSortType.EMAIL;
          break;
        case "exerciseType":
          result = ExerciceSortType.TYPENAME;
          break;
        case "disciplineName":
          result = ExerciceSortType.DISCIPLINE;
          break;
        default:
          break;
      }

      return result;
    },

    // on filters changed
    onFiltersChanged() {
      // reset to page 1
      this.options.page = 1;
      this.page = 1;
    },

    // On click to clear the title search input
    onClearTitleClicked() {
      this.searchParams.title = null;
      this.onFiltersChanged();
    },
    // On click to clear the destination search input
    onClearDestinationClicked() {
      this.searchParams.destinationType = null;
      this.onFiltersChanged();
    },
    // On click to clear the discipline search input
    onClearDisciplineClicked() {
      this.searchParams.discipline = null;
      this.onFiltersChanged();
    },
    // On click to clear the user search input
    onClearUserClicked() {
      this.searchParams.user = null;
      this.onFiltersChanged();
    },
    // On click to clear the type search input
    onClearTypeClicked() {
      this.searchParams.exerciseType = null;
      this.onFiltersChanged();
    },

    // Validate the selected exercise : close modal and send selected to parent
    validExercise() {
      bus.$emit("reference", this.selectedExercise[0]);
      this.emptySelectionAndCollapseTree();
      this.$emit("close-menu");
      this.close();
    },

    // return true if an exercise is selected
    canValidateExercise() {
      return this.selectedExercise[0] != null;
    },

    // Empty selected and collapse tree
    emptySelectionAndCollapseTree() {
      // Empty selected value
      this.selectedExercise = [];
    },

    // Unselect and close the modal
    closeModal() {
      this.emptySelectionAndCollapseTree();
      this.$emit("close-menu");
      this.close();
    },

    // When an exercise is selected, load the first media if exists
    async loadSelectedExerciseFirstMedia() {
      // if an exercise is selected
      if (this.exercices) {
        for (let i = 0; i < this.exercices.length; i++) {
          // If there are no preview but there is a firtMedia
          if (!this.exercices[i].preview && this.exercices[i].firstMedia) {
            let result;
            let response;
            const urlCreator = window.URL || window.webkitURL;

            switch (this.exercices[i].firstMedia.mediaType) {
              // CASE 1 => IMAGE
              case 1:
                response = await getDownloadMediaByPathAsync(this.exercices[i].firstMedia.url);
                if (response !== undefined) {
                  result = await response.blob();
                  if (result) {
                    this.exercices[i].firstMedia.image = urlCreator.createObjectURL(result);
                  }
                }
                break;
              // CASE 2 => VIDEO
              case 2:
                response = await getDownloadMediaByPathAsync(this.exercices[i].firstMedia.url);
                if (response != undefined) {
                  result = await response.blob();
                  if (result) {
                    this.exercices[i].firstMedia.image = require("../../assets/Placeholder_video.jpg");
                    this.exercices[i].firstMedia.videoOptions = {
                      techOrder: ["html5", "youtube"],
                      autoplay: false,
                      controls: true,
                      responsive: true,
                      sources: [
                        {
                          src: urlCreator.createObjectURL(result),
                          type: response.headers.get("Content-Type"),
                        },
                      ],
                    };
                  }
                }
                break;
              // CASE 3 => OTHER
              case 3:
                // TODO ?
                break;
              // CASE 4 => URL
              case 4:
                this.exercices[i].firstMedia.image = require("../../assets/Placeholder_lien.jpg");
                const parse = require("url-parse");
                const parsed = parse(this.exercices[i].firstMedia.url, true);
                const youtubeRegex = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/gim;
                const pictureRegex = /http[s]?:\/\/.+\.(jpeg|png|jpg|gif)/gim;
                this.exercices[i].firstMedia.src = this.exercices[i].firstMedia.url;
                if (parsed.hostname.includes("canal-sport") && parsed.pathname.endsWith("player")) this.exercices[i].firstMedia.canal = true;
                else if (youtubeRegex.exec(this.exercices[i].firstMedia.url)) {
                  this.exercices[i].firstMedia.youtube = true;
                  this.exercices[i].firstMedia.videoOptions = {
                    techOrder: ["html5", "youtube"],
                    autoplay: false,
                    controls: true,
                    responsive: true,
                    sources: [
                      {
                        src: this.exercices[i].firstMedia.url,
                        type: "video/youtube",
                      },
                    ],
                  };
                } else if (pictureRegex.exec(this.exercices[i].firstMedia.url)) {
                  this.exercices[i].firstMedia.isImage = true;
                  this.exercices[i].firstMedia.image = this.exercices[i].firstMedia.url;
                }
                break;
            }
          }
        }
      }
    },

    // return if ze should display the discipline column in the table
    shouldDisplayDisciplineInTable() {
      return _.includes(this.authorizedDestinationTypes, DestinationType.DISCIPLINE) || _.includes(this.authorizedDestinationTypes, DestinationType.COACH);
    },
  },
};
</script>
